import React, { Component } from 'react';
import { Route, Link,Switch } from 'react-router-dom';

import Input from './components/Input'
import ServiceTerms from './components/ServiceTerms'
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div  style={{overflow:'hidden',height: '100%'}}>
        <Switch>
          <Route exact path="/" component={Input}/>
          <Route path="/service-terms" component={ServiceTerms}/>
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js